import { superadminLoginState } from '../state/superadminLoginState'
import {APPLICATION_EAUTPOTP,ADD_EAUTPOTP,APPLICATION_VAUTHOTP,ADD_VAUTHOTP, APPLICATION_COMMONMETHOD,ADD_COMMONMETHOD,ADD_ACTIVATEAUTH,APPLICATION_ACTIVATEAUTH,ADD_ADDAUTH,APPLICATION_ADDAUTH,ADD_COMPANY_REQUEST,APPLICATION_REQUEST,FETCH_SUPER_ADMIN_LOGIN_REQUEST, FETCH_SUPER_ADMIN_LOGIN_SUCCESS, FETCH_SUPER_ADMIN_LOGIN_ERROR, LOGOUT_SUPER_ADMIN_REQUEST } 
from '../actions/superAdminLoginAction'


export function superAdminLoginReducer(state = superadminLoginState, action) {
    
    switch (action.type) {
           case ADD_EAUTPOTP:
          
                    return Object.assign({}, state, {
                        errorCode: action.errorCode,
                        statusCode: action.statusCode,
                        isLoading: false,
                        Message: action.errorMessage,
                        EisCodeVerifiedt: action.isCodeVerified
                    })
                        case APPLICATION_EAUTPOTP:
                    return Object.assign({}, state, {
                        errorCode: 0,
                        statusCode: 0,
                        isLoading: action.isLoading,
                        Message: ''
                    })
         case ADD_VAUTHOTP:
          
                    return Object.assign({}, state, {
                        errorCode: action.errorCode,
                        statusCode: action.statusCode,
                        isLoading: false,
                        Message: action.errorMessage,
                        VisCodeVerifiedt: action.isCodeVerified
                    })
                        case APPLICATION_VAUTHOTP:
                    return Object.assign({}, state, {
                        errorCode: 0,
                        statusCode: 0,
                        isLoading: action.isLoading,
                        Message: ''
                    })
             case ADD_COMMONMETHOD:
          
                    return Object.assign({}, state, {
                        errorCode: action.errorCode,
                        statusCode: action.statusCode,
                        isLoading: false,
                        Message: action.errorMessage,
                        removeAccountObject: action.removeAccountObject
                    })
                        case APPLICATION_COMMONMETHOD:
                    return Object.assign({}, state, {
                        errorCode: 0,
                        statusCode: 0,
                        isLoading: action.isLoading,
                        Message: ''
                    })
         case ADD_ACTIVATEAUTH:
          
                    return Object.assign({}, state, {
                        errorCode: action.errorCode,
                        statusCode: action.statusCode,
                        isLoading: false,
                        Message: action.errorMessage,
                        activateAppUserSucceeded: action.activateAppUserSucceeded
                    })
                        case APPLICATION_ACTIVATEAUTH:
                    return Object.assign({}, state, {
                        errorCode: 0,
                        statusCode: 0,
                        isLoading: action.isLoading,
                        Message: ''
                    })
          case ADD_ADDAUTH:
          
                    return Object.assign({}, state, {
                        errorCode: action.errorCode,
                        statusCode: action.statusCode,
                        isLoading: false,
                        Message: 'Success',
                        authAppUser: action.authAppUser
                    })
                        case APPLICATION_ADDAUTH:
                    return Object.assign({}, state, {
                        errorCode: 0,
                        statusCode: 0,
                        isLoading: action.isLoading,
                        Message: ''
                    })
          case ADD_COMPANY_REQUEST:
          
                    return Object.assign({}, state, {
                        errorCode: action.errorCode,
                        statusCode: action.statusCode,
                        isLoading: false,
                        Message: 'Success',
                        brandList: action.brandList
                    })
                        case APPLICATION_REQUEST:
                    return Object.assign({}, state, {
                        errorCode: 0,
                        statusCode: 0,
                        isLoading: action.isLoading,
                        Message: ''
                    })
        case FETCH_SUPER_ADMIN_LOGIN_REQUEST:
            return Object.assign({}, state, {
                userName: action.userName,
                isLoading: action.isLoading,
                password: action.password
            })
    
        case FETCH_SUPER_ADMIN_LOGIN_SUCCESS:
            return Object.assign({}, state, {
                userName: action.userName,
                isLoading: action.isLoading,
                password: action.password,
                Message: action.Message,
                loginStatus: action.loginStatus,
                authTokenId: action.authTokenId,
                adminId: action.userId,
                loginDetails:action.loginDetails
            })
        case FETCH_SUPER_ADMIN_LOGIN_ERROR:
        
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                Message: action.Message,
                loginStatus:action.loginStatus   
            })
        case LOGOUT_SUPER_ADMIN_REQUEST:
            return Object.assign({}, state, {
                userName: action.userName,
                isLoading: action.isLoading,
                password: action.password,
                Message: action.Message,
                loginStatus: action.loginStatus,
                authTokenId: action.authTokenId,
                adminId: action.adminId,
                //loginDetails:action.loginDetails
            })
        default:
            return state;
    }
} 
